export default __webpack_public_path__ + "4231864331030f0ad7d65d40738d1fcc.woff2";